import Colors from '../../styles/Colors';

const formikErrorTextStyles = () => ({
  text: {
    color: Colors.brightRed,
  },
});

export default formikErrorTextStyles;
